export default __webpack_public_path__ + "static/media/copy.e77a7023.svg";